module.exports = __webpack_public_path__ + "img/empty-work-schedule.0d6eb259.png";